module.exports = __webpack_public_path__ + "static/img/zhenling.223eb5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/zhenling.png
// module id = p/5h
// module chunks = 24